import { render, staticRenderFns } from "./housingTypeManagement.vue?vue&type=template&id=4c95edf6&"
import script from "./housingTypeManagement.vue?vue&type=script&lang=js&"
export * from "./housingTypeManagement.vue?vue&type=script&lang=js&"
import style0 from "./housingTypeManagement.vue?vue&type=style&index=0&id=4c95edf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports